import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { submitDynamicFormDataToApi } from "@midland-industries/Services/DynamicFormService";
import {
    SubmitDynamicFormApiRequestModel,
    SubmitDynamicFormApiResponseModel,
} from "@midland-industries/Types/DynamicFormModels";

type SubmitDynamicFormParameter = {
    onError?: (error: string) => void;
} & HasOnSuccess<SubmitDynamicFormApiResponseModel> & {
        data: SubmitDynamicFormApiRequestModel;
    };

type HandlerType = ApiHandler<SubmitDynamicFormParameter, ServiceResult<SubmitDynamicFormApiResponseModel>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await submitDynamicFormDataToApi(props.apiParameter.data);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const submitDynamicForm = createHandlerChainRunner(chain, "SubmitDynamicForm");
export default submitDynamicForm;
